import { z } from 'zod';

import { Integration } from '@tig-dpqa-cloud/contract-backend-common';

export const IntegrationListResponse = z.array(Integration.pick({ integrator: true, version: true }));

export type IntegrationListResponseType = z.infer<typeof IntegrationListResponse>;

export const IntegrationRequestParams = z.object({
  integrator: z.string().describe('The integration type'),
  version: z.string().describe('The integration version'),
});

export type IntegrationRequestParamsType = z.infer<typeof IntegrationRequestParams>;

export const IntegrationPutRequestBody = Integration.pick({ configuration: true });

export type IntegrationPutRequestBodyType = z.infer<typeof IntegrationPutRequestBody>;

export const IntegrationPostRequestBody = Integration;

export type IntegrationPostRequestBodyType = z.infer<typeof IntegrationPostRequestBody>;
